<template>
  <div id="frt">
    <section v-if="!loginAlready" class="section">
        <h1 class="subtitle">โปรดแสดง QR Code ของคุณ</h1>
        <h2 class="subtitle">

          <div class="qrframe" style="">
            <qrcode-stream @decode="onDecode"></qrcode-stream>
          </div>
          <img v-show="startLogin" src="https://icon-library.com/images/progress-icon-gif/progress-icon-gif-23.jpg">
        </h2>
    </section>
    <section v-if="loginAlready" class="section profile">
      <div class="card profileBox">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img src="https://www.searchpng.com/wp-content/uploads/2019/02/Men-Profile-Image-715x657.png" alt="Placeholder image">
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-6">{{staffInfo.name}} {{staffInfo.surname}}</p>
              <p class="subtitle is-6">{{staffInfo.code}}</p>
              <button class="button is-danger btn_logout" @click="logout">Logout</button>
            </div>
          </div>
        </div>
      </div>

    </section>
    <section v-if="loginAlready && !jobId" class="section">
      <img v-show="startSearchJob" src="https://icon-library.com/images/progress-icon-gif/progress-icon-gif-23.jpg">
      <div class="columns">
        <div class="column is-4 card jobCard" v-for="car in carList" v-bind:key="car.runNo" @click="selectJob(car.runNo, car)">
          <b>{{car.runNo}}</b><br>
          {{car.licenseNo}}<br>
          (นัดรับ {{car.expectedTime}}<br>{{car.expectedDate}})
        </div>
      </div>
    </section>
    <section v-if="jobId" class="section">
      <div class="card jobBox">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{jobSelect.runNo}}</p>
              <p class="subtitle is-6">นัดรับ {{jobSelect.expectedDate}} {{jobSelect.expectedTime}} </p>
            </div>
          </div>

          <div class="content jobContent">
            SA ผู้เปิดงาน: <span v-if="SAInfo">{{SAInfo.name}}</span><br>
            เปิดงานเมื่อ: {{formatDate(jobSelect.createdAt)}}
            <br><br><br><br>
          </div>

        </div>
        <footer class="card-footer">
          <a href="#" style="margin: 0 10px;" class="card-footer-item button is-info" @click="jobStart" v-if="jobStatus !== 'start'">เริ่มงาน</a>
          <a href="#" style="margin: 0 10px;" class="card-footer-item button is-warning" @click="jobPause" v-if="jobStatus === 'start'">พักงาน</a>
          <a href="#" style="margin: 0 10px;" class="card-footer-item button is-success" @click="jobFinish" v-if="jobStatus !== null">ส่งงาน</a>
        </footer>
      </div>
    </section>

  </div>
</template>
<style>
#frt {
  height: 100%;
  /* background-color: #999 !important;; */
}
.profileBox {
  width: 97%;
  height: 90px;
}
.jobBox {
  width: 97%;
}
.jobContent {
  text-align: left;
}
.btn_logout {
  position: absolute;
  top: 10px;
  right: 10px;
}
.profile {
  height: 90px;
  padding: 20px;
}
.jobCard {
  float: left;
  margin: 13px;
  font-size: 13px;
  text-align: center;
}

.qrframe {
  width: 300px;
  height: 300px;
  padding: 50px;
  background: url("https://static.thenounproject.com/png/59262-200.png");
  background-repeat: no-repeat;
  background-size: 300px 300px;
}
</style>
<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

export default {
  name: 'FRTControl',
  beforeCreate () {

  },
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  data: () => ({
    staffId: null,
    loginAlready: false,
    staffInfo: null,
    startLogin: false,
    startSearchJob: false,
    carList: null,
    branchCode: 10143,
    jobAlready: false,
    jobId: null,
    jobSelect: null,
    SAInfo: null,
    jobStatus: null
  }),
  mounted () {

  },
  methods: {
    jobStart () {
      this.jobStatus = 'start'
    },

    jobPause () {
      this.jobStatus = 'pause'
    },

    jobFinish () {
      this.jobId = null
      this.jobAlready = false
      this.jobSelect = null
      this.jobStatus = null
    },

    onDecode (decodedString) {
      if (decodedString !== '') {
        this.staffId = decodedString
        this.getStaffInfo()
      }
    },

    async getStaffInfo () {
      this.startLogin = true
      this.loginAlready = false
      await this.$axios
        .get(`${this.$apiUrl}getStaffById?code=${this.staffId}`)
        .then(response => {
          this.loginAlready = true
          this.startLogin = false
          this.staffInfo = response.data[0]
          this.getCarList()
        })
    },

    async getSA (staffId) {
      this.SAInfo = null
      await this.$axios
        .get(`${this.$apiUrl}getStaffById?code=${staffId}`)
        .then(response => {
          this.SAInfo = response.data[0]
        })
    },

    getCarList () {
      this.startSearchJob = true
      this.jobAlready = false
      this.$axios
        .get(`${this.$apiUrl}getJobsNotComplete?branch=${this.branchCode}`)
        .then(response => {
          this.jobAlready = true
          this.startSearchJob = false
          this.carList = response.data

          this.carList.sort((a, b) => {
            let keyA = a.runNo
            let keyB = b.runNo
            // Compare the 2 dates
            if (keyA < keyB) return -1
            if (keyA > keyB) return 1
            return 0
          })
        })
    },

    selectJob (jobId, job) {
      this.jobId = jobId
      this.jobSelect = job
      this.getSA(job.createdBy)
    },

    logout () {
      this.staffInfo = null
      this.staffId = null
      this.loginAlready = false
      this.jobAlready = false
      this.jobId = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FRT/control.vue